
  import {Component, Prop, Vue, Watch} from "vue-property-decorator";

  @Component
  export default class Aside extends Vue {
    // 当前激活的菜单
    private activeNav: string = '/item/list';
    // 跳转到子页面时的菜单栏的显示控制
    private navFormat: {reg: any, showPath: string}[] = [
      {
        reg: /^(\/edit\/modify)/,
        showPath: '/edit/list'
      },
      {
        reg: /^(\/edit\/copy)/,
        showPath: '/edit/add'
      }
    ]
    created(){
      this.setNav(this.$route, null)
    }
    /**
     * 监控路由变化设置导航激活
     * @param newVal
     * @param oldVal
     */
    @Watch('$route')
    setNav(newVal: any, oldVal: any): string {
      for (let item of this.navFormat) {
        if (item.reg.test(newVal.path)) {
          return this.activeNav = item.showPath
        }
      }
      this.activeNav = newVal.path
      return this.activeNav = newVal.path
    };

    get authorityList() {
      return this.$store.state.authorityList
    }

  }

